export default __webpack_public_path__ + "media/centauro_344px_113px-02.png";